import { useQuery } from "@tanstack/react-query";
import { useParams } from "@tanstack/react-router";
import { EmptyState } from "@snowiespace/ui/web";
import { client } from "./api.js";
import { AppRuntimeView } from "./app-runtime-view.js";
import { ui } from "./styles.js";

export function ReleasedApp() {
  const { spaceId, appId } = useParams({ from: "/spaces/$spaceId/apps/$appId" });
  const composition = useQuery({ queryKey: ["composition", spaceId], queryFn: () => client.composition(spaceId) });
  if (!composition.data) return <div className={ui("page")}><EmptyState title="Opening App">Reading its exact active release…</EmptyState></div>;
  const release = composition.data.active.manifest.appReleases.find((item) => item.appId === appId);
  const packageRef = release ? composition.data.active.manifest.packages.find((item) => item.digest === release.packageDigest) : undefined;
  const view = packageRef?.manifest.views.find((item) => item.kind === "app_runtime");
  if (!release || !packageRef || !view?.asset) return <div className={ui("page")}><EmptyState title="App is not released">Open Workbench to create a Trial or release an exact version.</EmptyState></div>;
  return <AppRuntimeView
    spaceId={spaceId}
    appId={appId}
    source={release.source}
    sourceDigest={release.sourceDigest}
    moduleId={packageRef.moduleId}
    title={release.name}
    version={packageRef.version}
    asset={view.asset}
  />;
}
